import { render, staticRenderFns } from "./PersonalNoteModal.vue?vue&type=template&id=79934e54&"
import script from "./PersonalNoteModal.vue?vue&type=script&lang=ts&"
export * from "./PersonalNoteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports